import React from 'react';
import './Pricing.scss';

export const Pricing = () => {
  return (
    <div className="pricing">
      <h1 className="title">AccessLOOP Pricing</h1>
      <p>
        At AccessLOOP there are no up-front costs or monthly subscription fees – you only pay for the time and services you use. AccessLOOP provides all the functionality you need in one easy to use system. Both Human and AI captions are facilitated.
      </p>
      <h2>AccessLOOP Features:</h2>

      <p>
        <h3>
          <b>Streaming</b>
        </h3>
        <ul>
          <li>Multiple Concurrent Streams and destinations</li>
          <li>Compatible with all major platforms and bespoke platforms</li>
          <li>Advanced video and audio settings</li>
        </ul>
      </p>

      <p>
        <h3>
          <b>Captions</b>
        </h3>
        <ul>
          <li>Up to four Human Captioners with seamless handover functionality</li>
          <li>AI Captioning</li>
          <li>Hybrid events can be supported with captions on the stream and captions in the room.</li>
          <li>Hybrid captioning, Human and AI captions can be used together seamlessly</li>
          <li>Open and CEA 608/708 Closed Captioning for both Human captioners and AI captions</li>
          <li>Choice of caption size and position (open captions only)</li>
          <li>Choose from two or three-lines of captions</li>
          <li>Multi-language translated real-time captions for Human and AI captions</li>
          <li>Preview of captions for both producer and captioners</li>
          <li>In-room captions player for Hybrid events</li>
          <li>Caption alignment features to make sure your captions are exactly in time</li>
          <li>Overlay captions styling features so you can position your captions where ever you need them</li>
          <li>Font size and colour choices</li>
          <li>Background colour and choices including translucent</li>
        </ul>
      </p>

      <p>Please see below for the full list of usage costs.</p>
      <table>
        <tr>
          <th>Services</th>
          <th className="table-header">Price GBP (per hour)</th>
        </tr>
        <tr>
          <td>Human Caption Delivery<br/><i className="extrainfo">(open and closed)*</i></td>
          <td className="tdprice">£25</td>
        </tr>
        <tr>
          <td>AI Captions<br/><i className="extrainfo">(open and closed)</i></td>
          <td className="tdprice">£25</td>
        </tr>
        <tr>
          <td>Language Translations<br/><i className="extrainfo">(human to AI &amp; AI to AI. Cost per language)</i></td>
          <td className="tdprice">£25</td>
        </tr>
        <tr>
          <td>Additional Destinations<br/><i className="extrainfo">(for all services)</i></td>
          <td className="tdprice">£5</td>
        </tr>
         <tr>
          <td style={{fontSize: 12}}>*All prices are exclusive of VAT</td>
          <td></td>
        </tr>                
      </table>

      <ul className="notes">
        <li>Each service used will have each per minute price calculated from the hourly rate. Minutes will be rounded up.</li>
        <li>* Human Captioners are not included in the costs - only the delivery of human captions.<br/>We have recommended suppliers who will provide these services so please contact us if you would like to discuss this further.</li>
      </ul>
    </div>
  );
};
